import _ from 'lodash';
import {MutationTree} from 'vuex';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationMutations: MutationTree<LtFramework.IAlertNotificationState> = {
	setAlertNotifications(state: LtFramework.IAlertNotificationState, payload: LtFramework.IAlertNotification[]) {
		state.alertNotifications = payload;
	},
};

export const ClubMutations: MutationTree<LtFramework.IClubState> = {
	setClub(state: LtFramework.IClubState, payload: LtFramework.IClub) {
		state.club = payload;
	},
};

export const ProfileMutations: MutationTree<LtFramework.IProfileState> = {
	setProfile(state: LtFramework.IProfileState, payload: LtFramework.IProfile) {
		state.profile = payload;
	},
};

export const UrlMutations: MutationTree<LtFramework.IUrlState> = {
	setUrl(state: LtFramework.IUrlState, payload: LtFramework.IUrl) {
		state.url = payload;
	},
};
